import React, { forwardRef } from 'react';
import Skeleton, { SkeletonProps } from '@mui/material/Skeleton';

/**
 * Eniac-style wrapper around MUI Skeleton.
 */
export interface IEDSkeletonProps extends SkeletonProps {
  testID?: string;
}

const EDSkeletonBase = forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<IEDSkeletonProps & { className?: string }>
>((props, ref) => {
  const { className, children, testID, ...rest } =
    props as React.PropsWithChildren<
      IEDSkeletonProps & { className?: string; testID?: string }
    >;

  return (
    <Skeleton
      data-testid={testID ? `${testID}` : undefined}
      className={className}
      ref={ref}
      {...rest}
    >
      {children}
    </Skeleton>
  );
});

const EDSkeleton = EDSkeletonBase as React.FC<
  React.PropsWithChildren<IEDSkeletonProps>
>;

export default EDSkeleton;
export { EDSkeleton };
